module.exports = __webpack_public_path__ + "static/media/18_B.12dd468d.png";